<template>
  <div>
    <div class="row" style="padding-top: 125px">
      <div class="col-md-4">
        <b-img-lazy
          v-for="image in images1"
          :key="image"
          :src="image"
          fluid
          class="thumbnail"
        />
      </div>
      <div class="col-md-4">
        <b-img-lazy
          v-for="image in images2"
          :key="image"
          :src="image"
          fluid
          class="thumbnail"
        />
      </div>
      <div class="col-md-4">
        <b-img-lazy
          v-for="image in images3"
          :key="image"
          :src="image"
          fluid
          class="thumbnail"
        />
      </div>
    </div>
    <div class="row" style="padding-bottom: 25px; padding-left: 20px">
      <a href="https://www.linkedin.com/in/josh-c-62024a81/">
        <img
          src="../assets/li.png"
          height="45px"
          style="padding-right: 10px"
        />
      </a>
      <a href="https://www.instagram.com/cowboycurtis__/">
        <img src="../assets/ig.png" width="45px" height="45px" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      shuffledImages: [],
    };
  },
  created() {
    // Get all images from gallery directory
    const path = require.context("@/assets/gallery", false, /.*$/);
    const allImages = path.keys().map(path);
    
    // Shuffle images randomly
    this.shuffledImages = this.shuffleArray([...allImages]);
  },
  computed: {
    images1() {
      return this.distributeImages(0);
    },
    images2() {
      return this.distributeImages(1);
    },
    images3() {
      return this.distributeImages(2);
    },
  },
  methods: {
    // Fisher-Yates shuffle algorithm
    shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    },
    // Distribute images round-robin for top density optimization
    distributeImages(columnIndex) {
      return this.shuffledImages.filter((_, index) => index % 3 === columnIndex);
    },
  },
};
</script>

<style scoped>
.thumbnail {
  width: 100%;
  padding: 0px;
  border: 0px solid #4d4e62;
}

a {
  text-decoration: none;
}
</style>
